<template>
	<div class="wrapper">
		<Abacus :isDemo="$route.path.startsWith('/demo')"></Abacus>
		<button class="btn btn-primary" @click="$router.go(-1)">
			{{ 'Back' | translate }}
		</button>
	</div>
</template>

<script>
import Abacus from './Game/Abacus'
export default {
	name: 'abacus-game',
	components: {
		Abacus,
	},
	created() {
		if (
			this.$store.state.gameConfig.id !== undefined ||
			this.$store.state.gameConfig.type === 'abacus_random'
		) {
			this.axios({
				method: 'post',
				url: 'https://games.pl.indigomental.com/',
				data: JSON.stringify({
					type: this.$store.state.gameConfig.type,
					digit: this.$store.state.gameConfig.digit,
					numbers: this.$store.state.gameConfig.numbers,
				}),
			}).then(resp => {
				let numbers = []
				let abacusPositions = []
				const digitToPosition = number => {
					let discharge = 1
					let numbersToArr = number
						.toString()
						.split('')
						.reverse()
					let position = {}
					for (let i = 0; i < 7; i++) {
						let numberToPosition = Number(numbersToArr[i])
						position[discharge] = {
							five: !isNaN(numberToPosition)
								? numberToPosition - 5 >= 0
								: false,
							digit: !isNaN(numberToPosition)
								? numberToPosition - 5 >= 0
									? numberToPosition - 5
									: numberToPosition
								: 0,
						}
						discharge = discharge * 10
					}
					return position
				}
				resp.data.items.forEach(item => {
					numbers.push(Number(`${item.sign}${item.number}`))
				})
				let sums = []
				numbers.reduce((sum, cur) => {
					sums.push(sum)
					return sum + cur
				})
				for (let i = 0; i < sums.length; i++) {
					abacusPositions.push(digitToPosition(sums[i]))
				}
				let item = 0
				let intervalId = setInterval(() => {
					this.$store.state.abacus = abacusPositions[item]
					item++
					if (item === abacusPositions.length - 1) {
						clearInterval(intervalId)
					}
				}, 1000)
			})
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
	/* height: calc(100vh - 150px); */
	justify-content: center;
	align-items: center;
	display: flex;
	flex-direction: column;
}

.btn {
	margin: 10px;
}
</style>
